/**
 * Name und Version der Plattform. Die Version steht an einer Stelle und wird vom Server (GET /api/v1/meta) und vom Backoffice gezeigt: in der Seitenleiste unten
 * und in Einrichtung → Über Wirkia. Bei jedem Release hier hochzählen (Schema: Hauptversion.Nebenversion.Korrektur). Weicht die Version des Servers von der des geladenen
 * Backoffice ab, zeigt „Über Wirkia“ den Hinweis, die Seite neu zu laden.
 */
export const APP_NAME = 'Wirkia';
export const APP_VERSION = '0.1.0';
/** Entwicklungsstand: solange „Vorabversion“ steht, kann sich noch etwas ändern */
export const APP_STAGE = 'Vorabversion';
export const APP_TAGLINE = 'Das modulare Backoffice für kleine Unternehmen';
/** Rechteinhaber für den Vermerk „© Jahr …“, zum Beispiel unten auf der Anmeldeseite */
export const APP_COPYRIGHT = 'ARTSA-IT Software Solutions';
/**
 * Angaben zum Anbieter für „Über Wirkia“. Was null ist, zeigt die Seite nicht. Hier Firma, Anschrift und Kontakt eintragen, sobald sie feststehen.
 */
export const APP_VENDOR = {
    name: null,
    address: null,
    email: null,
    website: null,
    phone: null,
};
//# sourceMappingURL=version.js.map